/**
 * @generated SignedSource<<e159115c7167c71b0fe8c701e6867424>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Avatar_actor$data = {
  readonly __typename: "ConnectActor";
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_connectActor">;
  readonly " $fragmentType": "Avatar_actor";
} | {
  readonly __typename: "GroupActor";
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_groupActor">;
  readonly " $fragmentType": "Avatar_actor";
} | {
  readonly __typename: "ScreenActor";
  readonly screen: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "Avatar_actor";
} | {
  readonly __typename: "UserActor";
  readonly storeUser: {
    readonly employee: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
    } | null;
    readonly user: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
    };
  } | null;
  readonly " $fragmentType": "Avatar_actor";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "Avatar_actor";
};
export type Avatar_actor$key = {
  readonly " $data"?: Avatar_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_actor",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Employee",
              "kind": "LinkedField",
              "name": "employee",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Avatar_employee"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Avatar_user"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StorecastScreen",
          "kind": "LinkedField",
          "name": "screen",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ScreenActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_groupActor"
        }
      ],
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_connectActor"
        }
      ],
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};
})();

(node as any).hash = "1eb5441e6f77906a744ee4cf72a62fbb";

export default node;
